// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ObjectSelectionModal_modal__YHI91 {
  background-color: #F6F7F8;
  padding-left: 0;
  padding-right: 0;
}
@media (min-width: 576px) {
  .ObjectSelectionModal_modal__YHI91 {
    padding-left: 40px;
    padding-right: 40px;
  }
}
.ObjectSelectionModal_modal__YHI91 .modal__overlay, .ObjectSelectionModal_modal__YHI91 .modal__close-btn {
  display: none;
}
.ObjectSelectionModal_modal__YHI91 .modal__inner {
  max-width: 560px;
  position: static;
  background: none;
}
@media (min-width: 576px) {
  .ObjectSelectionModal_modal__YHI91 .modal__inner {
    background-color: var(--white);
  }
}

.ObjectSelectionModal_header__M1dQt {
  position: absolute;
  left: 0;
  right: 0;
  top: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 1200px) {
  .ObjectSelectionModal_header__M1dQt {
    top: 22px;
  }
  .ObjectSelectionModal_header__M1dQt .ObjectSelectionModal_logo__u2VG- svg,
  .ObjectSelectionModal_header__M1dQt .ObjectSelectionModal_logo__u2VG- img {
    max-width: 150px;
    max-height: 150px;
  }
}
@media (max-width: 640px) {
  .ObjectSelectionModal_header__M1dQt .ObjectSelectionModal_logo__u2VG- svg,
  .ObjectSelectionModal_header__M1dQt .ObjectSelectionModal_logo__u2VG- img {
    max-width: 100px;
    max-height: 100px;
  }
}

.ObjectSelectionModal_logo__u2VG- svg,
.ObjectSelectionModal_logo__u2VG- img {
  max-width: 200px;
  max-height: 120px;
  height: auto;
}

div.ObjectSelectionModal_lang__ETY8K {
  position: absolute;
  top: 0;
  right: 12px;
}
@media (min-width: 640px) {
  div.ObjectSelectionModal_lang__ETY8K {
    right: 30px;
  }
}

.ObjectSelectionModal_logoTxt__BzrZk {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  color: var(--gray-500);
  display: flex;
}

.ObjectSelectionModal_projects-container__8ZlYV {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.ObjectSelectionModal_projects-container__header__T9Eo- {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.ObjectSelectionModal_projects-container__title__gOM1P {
  font-weight: 500;
  font-size: 24px;
  line-height: 100%;
}
.ObjectSelectionModal_projects-container__subtitle__rX6-c {
  font-weight: 400;
  font-size: 14px;
  line-height: 114%;
}
.ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_projects__zpiJ1 {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 440px;
  overflow-y: auto;
}
.ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_project-item__L96Aa {
  padding: 6px 4px;
  display: flex;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #E0E7EB;
  cursor: pointer;
}
.ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_project-item__L96Aa:last-child {
  border-bottom: none;
}
.ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_project-item__avatar__-7rjL {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}
.ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_project-item__content__FEYpS {
  width: 100%;
  display: flex;
  flex-direction: column;
  font-weight: 400;
  font-size: 16px;
  overflow: hidden;
}
.ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_project-item__content__FEYpS * {
  line-height: 114%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_project-item__descr__rVlP8 {
  font-size: 12px;
  color: #7A808B;
}
.ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_project-item__arrow__pfzRE {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border-radius: 50%;
  transition: left 0.3s ease;
  left: 0;
}
.ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_project-item__loader__WsTxx {
  background: var(--accent-color);
  width: 28px;
  height: 28px;
  position: relative;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_project-item__loader__WsTxx .btn-loader {
  width: 18px;
  height: 18px;
  right: auto;
}
.ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_project-item__loader__WsTxx .btn-loader img {
  width: 18px;
  height: 18px;
}
@media (hover: hover) {
  .ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_project-item__L96Aa:hover .ObjectSelectionModal_project-item__arrow__pfzRE {
    background: var(--accent-color);
    left: -10px;
  }
  .ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_project-item__L96Aa:hover .ObjectSelectionModal_project-item__arrow__pfzRE svg {
    fill: white;
  }
}
.ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_loader-container__G9EQN {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_loader-container__G9EQN .ObjectSelectionModal_skeletonBlock__vjOlr {
  height: 44px;
  border-radius: 12px;
}
@media (max-width: 576px) {
  .ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_loader-container__G9EQN .ObjectSelectionModal_skeletonBlock__vjOlr {
    height: 72px;
  }
}
@media (max-width: 576px) {
  .ObjectSelectionModal_projects-container__header__T9Eo- {
    align-items: flex-start;
  }
  .ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_project-item__L96Aa {
    background: #EEEEEE;
    padding: 12px 8px 12px 12px;
    border-radius: 12px;
    border: none;
  }
  .ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_project-item__avatar__-7rjL {
    width: 40px;
    height: 40px;
  }
  .ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_project-item__content__FEYpS {
    gap: 2px;
  }
  .ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_project-item__content__FEYpS * {
    white-space: normal;
    text-overflow: initial;
  }
  .ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_project-item__arrow__pfzRE {
    width: 24px;
    height: 24px;
  }
  .ObjectSelectionModal_projects-container__8ZlYV .ObjectSelectionModal_project-item__arrow__pfzRE svg {
    height: 12px;
    width: 7px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/ObjectSelectionModal/ObjectSelectionModal.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AACF;AACE;EALF;IAMI,kBAAA;IACA,mBAAA;EAEF;AACF;AAGM;EAEE,aAAA;AAFR;AAKM;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AAHR;AAKQ;EALF;IAMI,8BAAA;EAFR;AACF;;AAQA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALF;AAOE;EATF;IAUI,SAAA;EAJF;EAQI;;IAEE,gBAAA;IACA,iBAAA;EANN;AACF;AAUE;EAGI;;IAEE,gBAAA;IACA,iBAAA;EAVN;AACF;;AAiBE;;EAEE,gBAAA;EACA,iBAAA;EACA,YAAA;AAdJ;;AAkBA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;AAfF;AAiBE;EALF;IAMI,WAAA;EAdF;AACF;;AAiBA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAAA;EACA,aAAA;AAdF;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAdF;AAgBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AAdJ;AAiBE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAfJ;AAkBE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAhBJ;AAmBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AAjBJ;AAoBE;EACE,gBAAA;EACA,aAAA;EACA,QAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;AAlBJ;AAoBI;EACE,mBAAA;AAlBN;AAqBI;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAnBN;AAsBI;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AApBN;AAsBM;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AApBR;AAwBI;EACE,eAAA;EACA,cAAA;AAtBN;AAyBI;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,OAAA;AAvBN;AA0BI;EACE,+BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxBN;AA2BQ;EACE,WAAA;EACA,YAAA;EACA,WAAA;AAzBV;AA2BU;EACE,WAAA;EACA,YAAA;AAzBZ;AA+BI;EAEI;IACE,+BAAA;IACA,WAAA;EA9BR;EAgCQ;IACE,WAAA;EA9BV;AACF;AAoCE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAlCJ;AAoCI;EACE,YAAA;EACA,mBAAA;AAlCN;AAqCI;EACE;IACE,YAAA;EAnCN;AACF;AAuCE;EACE;IACE,uBAAA;EArCJ;EAwCE;IACE,mBAAA;IACA,2BAAA;IACA,mBAAA;IACA,YAAA;EAtCJ;EAwCI;IACE,WAAA;IACA,YAAA;EAtCN;EAyCI;IACE,QAAA;EAvCN;EAyCM;IACE,mBAAA;IACA,sBAAA;EAvCR;EA2CI;IACE,WAAA;IACA,YAAA;EAzCN;EA2CM;IACE,YAAA;IACA,UAAA;EAzCR;AACF","sourcesContent":[".modal {\n  background-color: #F6F7F8;\n  padding-left: 0;\n  padding-right: 0;\n\n  @media (min-width: 576px) {\n    padding-left: 40px;\n    padding-right: 40px;\n  }\n\n  :global {\n    .modal {\n\n      &__overlay,\n      &__close-btn {\n        display: none;\n      }\n\n      &__inner {\n        max-width: 560px;\n        position: static;\n        background: none;\n\n        @media (min-width: 576px) {\n          background-color: var(--white);\n        }\n      }\n    }\n  }\n}\n\n.header {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 42px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: 1200px) {\n    top: 22px;\n\n    .logo {\n\n      svg,\n      img {\n        max-width: 150px;\n        max-height: 150px;\n      }\n    }\n  }\n\n  @media (max-width: 640px) {\n    .logo {\n\n      svg,\n      img {\n        max-width: 100px;\n        max-height: 100px;\n      }\n    }\n  }\n}\n\n.logo {\n\n  svg,\n  img {\n    max-width: 200px;\n    max-height: 120px;\n    height: auto;\n  }\n}\n\ndiv.lang {\n  position: absolute;\n  top: 0;\n  right: 12px;\n\n  @media (min-width: 640px) {\n    right: 30px;\n  }\n}\n\n.logoTxt {\n  position: absolute;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  color: var(--gray-500);\n  display: flex;\n}\n\n.projects-container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  &__header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__title {\n    font-weight: 500;\n    font-size: 24px;\n    line-height: 100%;\n  }\n\n  &__subtitle {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 114%;\n  }\n\n  .projects {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    max-height: 440px;\n    overflow-y: auto;\n  }\n\n  .project-item {\n    padding: 6px 4px;\n    display: flex;\n    gap: 8px;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #E0E7EB;\n    cursor: pointer;\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    &__avatar {\n      width: 32px;\n      height: 32px;\n      flex-shrink: 0;\n    }\n\n    &__content {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      font-weight: 400;\n      font-size: 16px;\n      overflow: hidden;\n\n      * {\n        line-height: 114%;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n\n    &__descr {\n      font-size: 12px;\n      color: #7A808B;\n    }\n\n    &__arrow {\n      position: relative;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 16px;\n      height: 16px;\n      flex-shrink: 0;\n      border-radius: 50%;\n      transition: left 0.3s ease;\n      left: 0;\n    }\n\n    &__loader {\n      background: var(--accent-color);\n      width: 28px;\n      height: 28px;\n      position: relative;\n      border-radius: 50%;\n      flex-shrink: 0;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      :global {\n        .btn-loader {\n          width: 18px;\n          height: 18px;\n          right: auto;\n\n          img {\n            width: 18px;\n            height: 18px;\n          }\n        }\n      }\n    }\n\n    @media (hover: hover) {\n      &:hover {\n        .project-item__arrow {\n          background: var(--accent-color);\n          left: -10px;\n\n          svg {\n            fill: white;\n          }\n        }\n      }\n    }\n  }\n\n  .loader-container {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n\n    .skeletonBlock {\n      height: 44px;\n      border-radius: 12px;\n    }\n\n    @media (max-width: 576px) {\n      .skeletonBlock {\n        height: 72px\n      }\n    }\n  }\n\n  @media (max-width: 576px) {\n    &__header {\n      align-items: flex-start;\n    }\n\n    .project-item {\n      background: #EEEEEE;\n      padding: 12px 8px 12px 12px;\n      border-radius: 12px;\n      border: none;\n\n      &__avatar {\n        width: 40px;\n        height: 40px;\n      }\n\n      &__content {\n        gap: 2px;\n\n        * {\n          white-space: normal;\n          text-overflow: initial;\n        }\n      }\n\n      &__arrow {\n        width: 24px;\n        height: 24px;\n\n        svg {\n          height: 12px;\n          width: 7px;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `ObjectSelectionModal_modal__YHI91`,
	"header": `ObjectSelectionModal_header__M1dQt`,
	"logo": `ObjectSelectionModal_logo__u2VG-`,
	"lang": `ObjectSelectionModal_lang__ETY8K`,
	"logoTxt": `ObjectSelectionModal_logoTxt__BzrZk`,
	"projects-container": `ObjectSelectionModal_projects-container__8ZlYV`,
	"projects-container__header": `ObjectSelectionModal_projects-container__header__T9Eo-`,
	"projects-container__title": `ObjectSelectionModal_projects-container__title__gOM1P`,
	"projects-container__subtitle": `ObjectSelectionModal_projects-container__subtitle__rX6-c`,
	"projects": `ObjectSelectionModal_projects__zpiJ1`,
	"project-item": `ObjectSelectionModal_project-item__L96Aa`,
	"project-item__avatar": `ObjectSelectionModal_project-item__avatar__-7rjL`,
	"project-item__content": `ObjectSelectionModal_project-item__content__FEYpS`,
	"project-item__descr": `ObjectSelectionModal_project-item__descr__rVlP8`,
	"project-item__arrow": `ObjectSelectionModal_project-item__arrow__pfzRE`,
	"project-item__loader": `ObjectSelectionModal_project-item__loader__WsTxx`,
	"loader-container": `ObjectSelectionModal_loader-container__G9EQN`,
	"skeletonBlock": `ObjectSelectionModal_skeletonBlock__vjOlr`
};
export default ___CSS_LOADER_EXPORT___;
